import { Link, useNavigate } from 'react-router-dom';
import { Home, ArrowLeft, FileQuestion } from 'lucide-react';
import { Button } from '../../components/ui/Button';

export function NotFoundPage() {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen flex items-center justify-center bg-gray-50 dark:bg-gray-900 px-4">
      <div className="text-center max-w-md">
        {/* Icon */}
        <div className="mb-8">
          <div className="mx-auto w-24 h-24 bg-primary/10 dark:bg-primary/20 rounded-full flex items-center justify-center">
            <FileQuestion className="w-12 h-12 text-primary" />
          </div>
        </div>

        {/* Error Code */}
        <h1 className="text-6xl font-bold text-gray-900 dark:text-white mb-4">
          404
        </h1>

        {/* Message */}
        <h2 className="text-2xl font-semibold text-gray-800 dark:text-gray-200 mb-2">
          Page introuvable
        </h2>
        <p className="text-gray-600 dark:text-gray-400 mb-8">
          Désolé, la page que vous recherchez n'existe pas ou a été déplacée.
        </p>

        {/* Actions */}
        <div className="flex flex-col sm:flex-row gap-3 justify-center">
          <Button
            onClick={() => navigate(-1)}
            variant="outline"
            className="flex items-center gap-2"
          >
            <ArrowLeft className="w-4 h-4" />
            Retour
          </Button>
          
          <Link to="/">
            <Button className="flex items-center gap-2 w-full">
              <Home className="w-4 h-4" />
              Tableau de bord
            </Button>
          </Link>
        </div>

        {/* Suggestions */}
        <div className="mt-12 pt-8 border-t border-gray-200 dark:border-gray-700">
          <p className="text-sm text-gray-500 dark:text-gray-400 mb-4">
            Pages suggérées :
          </p>
          <div className="flex flex-wrap justify-center gap-2">
            <Link 
              to="/journals"
              className="text-sm text-primary hover:underline"
            >
              Journaux
            </Link>
            <span className="text-gray-300 dark:text-gray-600">•</span>
            <Link 
              to="/ledger"
              className="text-sm text-primary hover:underline"
            >
              Grand Livre
            </Link>
            <span className="text-gray-300 dark:text-gray-600">•</span>
            <Link 
              to="/reports"
              className="text-sm text-primary hover:underline"
            >
              États Financiers
            </Link>
            <span className="text-gray-300 dark:text-gray-600">•</span>
            <Link 
              to="/settings"
              className="text-sm text-primary hover:underline"
            >
              Paramètres
            </Link>
          </div>
        </div>
      </div>
    </div>
  );
}
